import { Divider, Select, SelectProps, Typography } from 'antd';
import { FC, useMemo } from 'react';

import { usePublisher } from '../PublisherProvider';

import styles from './styles.module.less';

const PublisherSelect: FC<SelectProps<string>> = (props) => {
  const [{ id: publisherId, name }, { publishers, setPublisherId }] =
    usePublisher();

  const options = useMemo(
    () =>
      publishers.map(({ id, name }) => ({
        'data-label': `${id} ${name}`,
        label: (
          <>
            {id}
            <Divider type="vertical" />
            {name}
          </>
        ),
        value: id,
      })),
    [publishers],
  );

  if (publishers.length === 1) {
    return <Typography.Text className={styles.text}>{name}</Typography.Text>;
  }

  return (
    <Select
      autoClearSearchValue
      dropdownMatchSelectWidth={false}
      onChange={setPublisherId}
      optionFilterProp="data-label"
      options={options}
      showSearch
      value={publisherId}
      {...props}
    />
  );
};

PublisherSelect.displayName = 'PublisherSelect';

export default PublisherSelect;
